import styled from 'styled-components';
import { mediaBreakpointUp } from '@whitelabel/helpers/style';

export const StyledTitle = styled.h2`
  margin-bottom: 1rem;
  font-weight: 500;
  line-height: 1.25;
  text-transform: none;

  ${mediaBreakpointUp('md')`
    margin-bottom: 2rem;
  `};
  ${mediaBreakpointUp('lg')`
    margin-bottom: 3rem;
  `};
`;
